import './SatzungListe.css';

function SatzungListe() {
  return (
    <div className="SatzungsListeDiv">
      <h2>Die Satzung des VdHR</h2>
      <ul>
        <li>
          <h3>1 Name und Sitz</h3>
          <p>
            §1.1 Der Verein soll ins Vereinsregister eingetragen werden und
            heißt dann Verband der HörspielRegie (VdHR).
          </p>
          <p>§1.2 Er hat seinen Sitz in Berlin.</p>
          <p>§1.3 Geschäftsjahr ist das Kalenderjahr.</p>
        </li>
        <li>
          <h3>2 Definition</h3>
          <p>
            Hörspielregisseur/Hörspielregisseurin im Sinne des Verbandes der
            Hörspielregisseure (VdHR) ist jede natürliche Person die
            nachweislich bei mindestens zwei Produktionen Regie geführt hat, die
            bei einer Sendeanstalt des öffentlichen Rechts zur Ausstrahlung
            gelangt sind. Die Ausstrahlung muss im Programmzusammenhang als
            Hörspiel (inklusive jeglicher Derivate: Kinderhörspiel,
            Kriminalhörspiel, usw.), Hörstück, Ars Acustica, Medienkunst,
            Radiodrama, Soundstory oder Radioplay ausgewiesen gewesen sein. In
            einzelnen Fällen können auch Radiofeature-Produktionen die genannten
            Bedingungen erfüllen, hier entscheidet der Vorstand über die
            Statthaftigkeit. Wird der Vorstandsbeschluss innerhalb von vier
            Wochen nach Ablehnung des Antrags angefochten, wird bei der nächsten
            Mitgliederversammlung über den Antrag entschieden.
          </p>
        </li>
        <li>
          <h3>3 Vereinszweck</h3>
          <p>§3.1 Zweck des Vereins ist</p>
          <p>
            · die Wahrung, Pflege und Förderung der beruflichen und
            wirtschaftlichen Interessen der deutschsprachigen Hörspielregisseure
            und -regisseurinnen;
          </p>
          <p>
            · die Interessenvertretung der Hörspielregisseure und
            -regisseurinnen gegenüber den Rundfunk- und Fernsehanstalten,
            Verlagen, Audioverwertern aller bestehenden und noch zu
            entwickelnden Formen, der Hörspielwirtschaft, den Gewerkschaften
            sowie Ministerien, gesetzgebenden Körperschaften und allen
            Institutionen der Hörspielförderung;
          </p>
          <p>
            · die Förderung des Hörspiels und der Hörspielbildung, sowie aktive
            Beteiligung der Hörspielregisseure und -regisseurinnen am
            kulturellen Leben;
          </p>
          <p>
            · die Förderung des Hörspiels, der Ars Acustica, des Hörfeatures und
            aller auditiven Formen allgemein als wesentlichen Bestandteil der
            deutschen und europäischen Kultur;
          </p>
          <p>
            · den Austausch von Erfahrungen und das Gespräch über Perspektiven
            sämtlicher auditiver Formen zwischen den Hörspielregisseuren
            anzuregen, zu stärken und zu pflegen;
          </p>
          <p>
            · die Kooperation mit künstlerisch Schaffenden anderer Fakultäten
            (Theater, Film, Musik, bildende Kunst usw.) aufzubauen und zu
            fördern;
          </p>
          <p>
            · die Erhaltung des für die auditiven Künste wichtigen historischen
            Erbes.
          </p>
          <p>
            §3.2 Der Verein wird als Vereinigung von
            Urhebern/Leistungsschutzberechtigten ermächtigt, gemeinsame
            Vergütungsregeln mit Vereinigungen von Werknutzern oder einzelnen
            Werknutzern gemäß § 36 UrhG aufzustellen.
          </p>
          <p>
            §3.3 Der Verein verfolgt auch das Ziel, wettbewerbswidrigen
            Zuständen und unzulässigen Allgemeinen Geschäftsbedingungen
            entgegenzutreten. Dieses Ziel soll insbesondere durch die
            Geltendmachung von Ansprüchen auf Unterlassung und auf Widerruf
            sowie durch das Aussprechen von Mittelstandsempfehlungen erreicht
            werden.
          </p>
        </li>
        <li>
          <h3>4 Selbstlosigkeit</h3>
          <p>
            Der Verein ist selbstlos tätig; er verfolgt nicht in erster Linie
            eigenwirtschaftliche Zwecke. Mittel des Vereins dürfen nur für die
            satzungsmäßigen Zwecke verwendet werden. Die Mitglieder erhalten
            keine Zuwendungen aus Mitteln des Vereins. Es darf keine Person
            durch Ausgaben, die dem Zweck der Körperschaft fremd sind, oder
            durch unverhältnismäßig hohe Vergütungen begünstigt werden.
          </p>
        </li>
        <li>
          <h3>5 Mitgliedschaft</h3>
          <p>
            §5.1 Mitglied kann jeder/jede Hörspielregisseur/In (nach § 2 der
            Satzung) werden. Dem schriftlichen Aufnahmeantrag kann der Vorstand
            innerhalb eines Monats widersprechen. Gegen den Beschluss des
            Vorstandes kann die Mitgliederversammlung angerufen werden.
          </p>
          <p>
            §5.2 Die Mitgliedschaft endet mit Tod, Austritt oder Ausschluss aus
            dem Verein.
          </p>
          <p>
            §5.3 Der Austritt kann nur zum Ende eines Kalenderjahres erfolgen
            und muss 3 Monate vor dem Jahresende schriftlich mitgeteilt werden.
          </p>
          <p>
            §5.4 Es werden Mitgliedsbeiträge erhoben. Der Mitgliedsbeitrag
            beträgt jährlich mindestens € 50,–. Fällig bis spätestens zum 15.
            Juni eines jeden Jahres.
          </p>
          <p>
            §5.5 Bei groben Verletzungen der Vereinspflichten, z. B.
            Nichtzahlung des Mitgliedsbeitrags trotz zweimaliger Mahnung, kann
            der Vorstand den Ausschluss eines Mitglieds beschließen. Gegen den
            Beschluss des Vorstandes kann die Mitgliederversammlung angerufen
            werden.
          </p>
        </li>
        <li>
          <h3>6 Mitgliederversammlung</h3>
          <p>
            §6.1 Das oberste Organ des Vereins ist die Mitgliederversammlung.
          </p>
          <p>
            §6.2 Eine ordentliche Mitgliederversammlung (Jahreshauptversammlung)
            findet einmal im Jahr statt.
          </p>
          <p>
            §6.3 Die Einberufung der Mitgliederversammlung erfolgt schriftlich
            durch den Vorstand (dies kann auch per Email erfolgen). Dabei ist
            die vom Vorstand festgesetzte Tagesordnung mitzuteilen. Zwischen dem
            Tag der Einladung und dem Termin der Versammlung soll eine Frist von
            2 Wochen liegen.
          </p>
          <p>
            §6.4 Mit der Einberufung der ordentlichen Mitgliederversammlung ist
            die Tagesordnung mitzuteilen, die folgende Punkte enthalten muss:
          </p>
          <p>a) Entgegennahme der Berichte</p>
          <p>b) Kassenbericht</p>
          <p>c) Entlastung des Vorstandes (nur bei Wahl)</p>
          <p>d) Wahlen des Vorstandes sowie des/der Revisors/Revisorin</p>
          <p>e) Beschlussfassung über die vorliegenden Anträge</p>
          <p>
            §6.5 Eine außerordentliche Mitgliederversammlung ist innerhalb einer
            Frist von zwei Wochen mit entsprechender Tagesordnung einzuberufen,
          </p>
          <p>a) wenn einviertel der Mitglieder dies beim Vorstand beantragt,</p>
          <p>b) auf Beschluss des Vorstandes.</p>
          <p>
            §6.6 Die Mitgliederversammlung ist unabhängig von der Zahl der
            anwesenden stimmberechtigten Mitglieder beschlussfähig.
          </p>
          <p>
            §6.7 Jedes Mitglied kann sich durch ein anderes Mitglied aufgrund
            einer schriftlichen Vollmacht vertreten lassen.
          </p>
          <p>
            §6.8 Entscheidungen werden, soweit nichts anderes geregelt ist, mit
            der Mehrheit der abgegebenen gültigen Stimmen getroffen;
            Stimmenthaltungen bleiben unberücksichtigt (einfache Mehrheit). Bei
            Stimmengleichheit gilt der Antrag als abgelehnt. Satzungsänderungen
            bedürfen einer Mehrheit von zwei Dritteln der abgegebenen Stimmen,
            wobei Stimmenthaltung unberücksichtigt bleibt.
          </p>
          <p>
            §6.9 Die Beschlüsse der Mitgliederversammlung werden protokolliert.
          </p>
        </li>
        <li>
          <h3>7 Vertretungsberechtigter Vorstand gem. § 26 BGB</h3>
          <p>
            Der Vorstand besteht aus dem ersten und dem zweiten Vorsitzenden.
            Jedes Vorstandsmitglied ist einzeln zur Vertretung des Vereins
            berechtigt.
          </p>
        </li>
        <li>
          <h3>8 Geschäftsführender Vorstand</h3>
          <p>
            §8.1 Die Mitgliederversammlung beschließt, ob und in welcher Anzahl
            weitere geschäftsführende, nicht vertretungsberechtigte
            Vorstandsmitglieder gewählt werden.
          </p>
          <p>
            §8.2 Der Vorstand ist für alle Vereinsangelegenheiten zuständig, die
            nicht durch Satzung ausdrücklich der Mitgliederversammlung
            zugewiesen sind.
          </p>
          <p>
            §8.3 Er fasst Beschlüsse mit einfacher Mehrheit, hierüber werden
            schriftliche Protokolle angefertigt. Der Vorstand ist
            beschlussfähig, wenn mindestens zwei Vorstandsmitglieder anwesend
            sind, hiervon mindestens eines der vertretungsberechtigten
            Vorstandsmitglieder.
          </p>
          <p>
            §8.4 Die einzelvertretungsberechtigten Vorstandsmitglieder sind an
            die Mehrheitsbeschlüsse des Vorstands gebunden.
          </p>
          <p>
            §8.5 Der Vorstand wird für die Dauer von 2 Jahren gewählt. Der
            Vorstand bleibt bis zur Wahl eines neuen Vorstandes im Amt.
          </p>
          <p>
            §8.6 Die Amtsdauer eines Vorstandsmitglieds endet mit dem Rücktritt,
            durch Tod, dem Eintritt der Geschäftsunfähigkeit oder durch Abwahl
            aus wichtigem Grund (vorsätzlich falsche Geschäftsführung sowie
            Zuwiderhandlung gegen den Vereinszweck) durch die
            Mitgliederversammlung. Die Vorstandsmitglieder können jederzeit
            schriftlich ihren Rücktritt erklären. Der Rücktritt wird frühestens
            mit Wahl des Nachfolgers wirksam. Die Wahl muss innerhalb von vier
            Wochen durch die Mitgliederversammlung erfolgen
          </p>
          <p>
            §8.7 Stehen der Eintragung im Vereinsregister bestimmte
            Satzungsinhalte entgegen, ist der Vorstand berechtigt, entsprechende
            Änderungen eigenständig durchzuführen.
          </p>
        </li>
        <li>
          <h3>9 Revision</h3>
          <p>
            Die Mitgliederversammlung wählt mindestens eine/n Revisor/in. Die
            Aufgaben sind die Rechnungsprüfung und die Überprüfung der
            Einhaltung der Satzungsvorgaben und Vereinsbeschlüsse.
          </p>
        </li>
        <li>
          <h3>10 Auflösung</h3>
          <p>
            Bei Auflösung des Vereins fällt das Vermögen an eine Organisation,
            einen Verein oder eine Initiative, welche die Förderung und Wahrung
            der Hörspielkunst zum Ziel hat. Über die Vergabe entscheidet die
            letzte stattfindende Mitgliederversammlung in einfacher Mehrheit.
          </p>
        </li>
      </ul>
    </div>
  );
}

export default SatzungListe;
